import React, { useEffect, useState } from 'react';
import SavingsOpportunitiesTable from './savingsOpportunitiesTable';
import CloudWasteChart from './cloudWasteChart';
import { getFiltersForSavingOpportunities } from 'recommendationsNew/components/heatMap/heatMapFilters/filterStates.js';
import { useRecommendationsNewContext } from 'recommendationsNew/contexts/recommendationsNewContext.jsx';
import classnames from 'classnames';
import HeatMapFilters from 'recommendationsNew/components/heatMap/heatMapFilters/mainFilters/heatMapFilters.jsx';
import { useHeatMapContext } from 'recommendationsNew/components/heatMap/contexts/heatMapContext.jsx';
import classes from './cloudWaste.module.scss';

const CloudWaste = () => {
  const { isHeatMapClosed } = useHeatMapContext();
  const [sizeKey, setSizeKey] = useState(0);
  const { recommendationFilters: filtersContext, setRecommendationFilters } = useRecommendationsNewContext();

  // window resize event
  useEffect(() => {
    setRecommendationFilters(getFiltersForSavingOpportunities(filtersContext));
    const handleResize = () => {
      setSizeKey((prev) => prev + 1);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <HeatMapFilters />
      {!isHeatMapClosed ? (
        <div className={classnames(classes.container, classes.tabWrapper)} key={sizeKey}>
          <SavingsOpportunitiesTable />
          <div className={classes.cloudWasteBorder}>
            <div className={classes.borderArrow} />
          </div>
          <CloudWasteChart />
        </div>
      ) : null}
    </>
  );
};

export default CloudWaste;
